import React, { useState } from 'react'
import SearchField from '../../../shared/SearchField'
import DatePicker from '../../../shared/DatePicker'
import CustomButton from '../../../shared/CustomButton'
import moment from 'moment'
import CustomTable from '../../../shared/CustomTable'
import { EyeIcon } from '../../../utils/TableActionIcons'
import DropdownField from '../../../shared/DropdownField'
import ReusableModal from '../../../shared/ReuseableModal'
import AddSubstoreReturn from './AddSubstoreReturn'
import {
  dummyRedData,
  ReturnedItemsColumns
} from '../../../constants/InverntoryConstants'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

function SubstoreReturn () {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [payloadData, setPayloadData] = useState({
    start_date: null,
    end_date: null
  })

  const handleChange = (date, name) => {
    setPayloadData({ ...payloadData, [name]: date })
  }
  const [open, setOpen] = useState(false)
  const [selectedData, setSelectedData] = useState(null)

  const ActionTemepelate = rowData => {
    return (
      <>
        <EyeIcon />
      </>
    )
  }

  const action = {
    body: ActionTemepelate,
    header: t('Actions'),
    headerCellClass: '!bg-gray-200'
  }

  const columns = [action, ...ReturnedItemsColumns(t)]

  return (
    <div>
      <div className='flex flex-wrap justify-between w-full gap-4 items-center'>
        <div className='w-full sm:w-auto'>
          <SearchField className='w-full sm:w-[300px]' placeholder='Search' />
        </div>

        <div className='flex flex-wrap justify-start w-full gap-3 items-start sm:w-auto'>
          <DropdownField
            placeholder={t('Substore')}
            useFormik={false}
            options={[]}
            className='w-full sm:w-[200px]'
          />
          <DatePicker
            name='start_date'
            value={
              payloadData?.start_date
                ? moment(payloadData?.start_date, 'YYYY-MM-DD').toDate()
                : ''
            }
            onChange={e => handleChange(e.target.value, 'start_date')}
            useFormik={false}
            placeholder={t('StartDate')}
            className='w-full sm:w-[200px]'
          />
          <DatePicker
            name='end_date'
            value={
              payloadData?.end_date
                ? moment(payloadData?.end_date, 'YYYY-MM-DD').toDate()
                : ''
            }
            onChange={e => handleChange(e.target.value, 'end_date')}
            useFormik={false}
            placeholder={t('EndDate')}
            className='w-full sm:w-[200px]'
          />
          <CustomButton
            label={t('ApplyFilters')}
            icon={'pi pi-filter'}
            className='h-[35px] w-full sm:w-fit'
          />
          <CustomButton
            label={t('ADD_RETURN')}

            icon='pi pi-plus'
            className='h-[35px] w-full sm:w-fit'
            onClick={() => setOpen(true)}
          />
        </div>
        <ReusableModal
          isVisible={open}
          onClose={() => setOpen(false)}  
          title={t('ADD_RETURN')}
          size='md'
        >
          <AddSubstoreReturn
            onClose={() => setOpen(false)}
            selectedData={selectedData}
          />
        </ReusableModal>
      </div>
      <div className='mt-4'>
        <CustomTable columns={columns} />
      </div>
    </div>
  )
}
export default SubstoreReturn
